module.exports = __webpack_public_path__ + "static/media/list_alt.c9e66165.svg";